import { render, staticRenderFns } from "./rejectedProduct.vue?vue&type=template&id=6e29f0e5&scoped=true"
import script from "./rejectedProduct.vue?vue&type=script&lang=js"
export * from "./rejectedProduct.vue?vue&type=script&lang=js"
import style0 from "./rejectedProduct.vue?vue&type=style&index=0&id=6e29f0e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e29f0e5",
  null
  
)

export default component.exports